import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "86",
  height: "86",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "5",
      d: "M35.147 23.338c.973-.404 2.243-.269 3.439.493l2.67 1.701a4.17 4.17 0 0 0 4.48.001l2.65-1.688c1.203-.765 2.478-.901 3.458-.495.975.404 1.778 1.395 2.09 2.778l.707 3.12c.179.791.583 1.478 1.115 2.01a4.15 4.15 0 0 0 2.032 1.123l3.092.682c1.385.307 2.379 1.108 2.782 2.081.404.974.268 2.244-.496 3.441l-1.704 2.67a4.15 4.15 0 0 0-.638 1.957l-.01.285.01.284c.038.571.193 1.15.48 1.689l.156.265 1.688 2.652c.766 1.202.901 2.477.496 3.457-.404.975-1.396 1.778-2.779 2.09l-3.12.707a4.1 4.1 0 0 0-1.804.922l-.206.193a4.2 4.2 0 0 0-1.045 1.735l-.077.297-.683 3.092c-.307 1.385-1.108 2.379-2.081 2.782-.974.404-2.244.268-3.44-.496l-2.67-1.704-.266-.155a4.2 4.2 0 0 0-1.977-.492c-.661 0-1.345.154-1.973.49l-.265.155-2.654 1.69c-1.2.764-2.474.9-3.453.495-.975-.405-1.778-1.397-2.09-2.78l-.702-3.117-.077-.291a4.1 4.1 0 0 0-.842-1.514l-.195-.208-.207-.194a4.14 4.14 0 0 0-1.826-.928l-3.09-.683c-1.387-.307-2.381-1.108-2.785-2.082s-.268-2.244.495-3.442l1.7-2.67a4.17 4.17 0 0 0 .001-4.478l-1.69-2.656c-.764-1.2-.9-2.472-.495-3.449.404-.975 1.397-1.777 2.78-2.088l3.114-.697a4.13 4.13 0 0 0 2.017-1.114 4.15 4.15 0 0 0 1.12-2.033l.686-3.099c.305-1.386 1.107-2.38 2.082-2.784Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "M73.267 78.985a22.6 22.6 0 0 0 5.718-5.718C83 67.467 83 59.31 83 43c0-16.31 0-24.466-4.015-30.267a22.6 22.6 0 0 0-5.718-5.718C67.467 3 59.31 3 43 3 26.69 3 18.534 3 12.733 7.015a22.6 22.6 0 0 0-5.718 5.718M65.23 82.06c-2.55.46-5.514.695-9.054.815M45.825 83 43 83c-4.09 0-7.667 0-10.824-.063m-13.647-1.37c-2.225-.587-4.11-1.415-5.796-2.582a22.6 22.6 0 0 1-5.718-5.718c-.896-1.294-1.592-2.706-2.133-4.3M3.073 54.295C3 51.024 3 47.294 3 43s0-8.024.073-11.294"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "5",
      d: "M42.998 37.5a5.51 5.51 0 0 1 5.495 5.23l.007.273a5.5 5.5 0 1 1-5.502-5.503Z"
    }, null, -1)
  ])))
}
export default { render: render }